import { render, staticRenderFns } from "./StatisticsExpansion.vue?vue&type=template&id=282aabd2&scoped=true&"
import script from "./StatisticsExpansion.vue?vue&type=script&lang=js&"
export * from "./StatisticsExpansion.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsExpansion.vue?vue&type=style&index=0&id=282aabd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282aabd2",
  null
  
)

export default component.exports